import { render, staticRenderFns } from "./PassengerGroupsPage.vue?vue&type=template&id=18bdd515"
import script from "./PassengerGroupsPage.vue?vue&type=script&lang=ts"
export * from "./PassengerGroupsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports